{
  "Ape 3 Detay": "Ape 3 Detay",
  "Müşteri": "Müşteri",
  "Sigorta Ettiren": "Sigorta Ettiren",
  "Ürün": "Ürün",
  "Police No": "Police No",
  "Ape": "Ape",
  "Vade Tarih": "Vade Tarih",
  "Durum": "Durum",
  "İşlem": "İşlem",
  "İptal Tarih": "İptal Tarihi",
  "İptal": "İptal",
  "Sil": "Sil"
}
